import React from 'react'
import PropTypes from 'prop-types'
import CtaButton from 'components/cta-button'
import Font from '@cred/react-font'
import { Testable } from '@cred/react-testable'
import { withStyles } from '@cred/react-theme'
import defaultStyles from './themes/default/styles.module.scss'
import homes1 from './themes/homes1/styles.module.scss'
import insider from './themes/insider/styles.module.scss'


const CheckList = ({ styles }) => (
  <ul className={styles.list}>
    <li className={`${styles.item} mb-8`}>
      <Font type="bodySmall" color="lighter">
        <i className={`${styles.icon} cred-icon icon-check`} />
        Get prequalified in just 3 minutes without impacting your credit score.
      </Font>
    </li>
    <li className={styles.item}>
      <Font type="bodySmall" color="lighter">
        <i className={`${styles.icon} cred-icon icon-check`} /> Compare rates from multiple lenders without
        your data being sold or getting spammed.
      </Font>
    </li>
  </ul>
)

CheckList.propTypes = {
  styles: PropTypes.object.isRequired,
}

const CompareRates = ({ onGetStarted, analyticsContexts, styles }) => (
  <Testable className={styles.container} testId="personalized-rates">
    <Font className={styles.headingText} type="medium" weight="bold">
      Get your personalized prequalified rates on Credible
    </Font>
    <div className={styles.checkList}>
      <CheckList styles={styles} />
    </div>
    <Testable testId="submit">
      <CtaButton
        className={styles.button}
        onClick={onGetStarted}
        analyticsContexts={analyticsContexts}
      >
        Compare Rates
      </CtaButton>
    </Testable>
  </Testable>
)

CompareRates.propTypes = {
  onGetStarted: PropTypes.func.isRequired,
  analyticsContexts: PropTypes.array.isRequired,
  styles: PropTypes.object,
}

CompareRates.defaultProps = {
  styles: defaultStyles,
}

export default withStyles(defaultStyles, { homes1, insider })(CompareRates)
